import React from 'react';
import ReactDOM from 'react-dom';

interface IPropsModal {
    children: any;
}

export class Modal extends React.Component<IPropsModal, {}> {
    private el: any;
    constructor(props: IPropsModal) {
        super(props);
        this.el = document.createElement('div');
    }

    public componentDidMount() {
        document.getElementById('root')?.firstElementChild?.appendChild(this.el);
    }

    public componentWillUnmount() {
        document.getElementById('root')?.firstElementChild?.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}
